module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAMAAABFjsb+AAAAb1BMVEVHcEwLV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV88LV8+LBETDAAAAJHRSTlMAkdzKAzkj/PgLFGNwZxoohPQZn2CrMnjm7NQsER+xwEa/ul/0zSt4AAAAlklEQVR42m3OWw+CMAyG4Q/G3AbIQSRi8IT2//9GW3phl/heLNmzZhuyau9r5B0DEbUZHZi4OhujPW/H3sZUpqAUbrwptmkVKc+fyNQA/chnUaQCuqa5A5hJGll+lXoJbE7nTn8+FQtVvWKIFIp2Ee3mGB6dYOoTL5crxYW40rwmurfC1Kp5ay+13lr1FHIVbGlwbkj4Auo5EKNEDt0oAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/ic_fx.png
// module id = jBsk
// module chunks = 1